import {Injectable} from '@angular/core';
import {MatSnackBar, MatSnackBarHorizontalPosition} from '@angular/material/snack-bar';
import {Observable} from 'rxjs';
import {ConfirmationDialogComponent} from './confirmation-dialog/confirmation-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {SnackBarComponent} from './snack-bar/snack-bar.component';

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  constructor(private snackBar: MatSnackBar, private dialog: MatDialog) {
  }

  showErrorSnackBar(message: string, action: string = null, duration: number = 2500): Observable<any> {
    return this.snackBar.openFromComponent(SnackBarComponent, {
      duration: duration,
      panelClass: 'snackbar',
      data: {
        icon_class: 'error',
        icon: 'error_outline',
        message: message,
        actionTitle: action,
      }
    }).onAction();
  }

  showBottomErrorSnackBar(message: string, action: string = null, duration: number = 2500): Observable<any> {
    return this.snackBar.openFromComponent(SnackBarComponent, {
      duration: duration,
      verticalPosition: 'bottom',
      horizontalPosition: 'center',
      panelClass: 'snackbar',
      data: {
        icon_class: 'error',
        icon: 'error_outline',
        message: message,
        actionTitle: action,
      }
    }).onAction();
  }

  showWarningSnackBar(message: string, action: string = null, duration: number = 1500): Observable<any> {
    return this.snackBar.openFromComponent(SnackBarComponent, {
      duration: duration,
      data: {
        icon_class: 'warning',
        icon: 'error_outline',
        message: message,
        actionTitle: action,
      }
    }).onAction();
  }

  showBottomWarningSnackBar(message: string, action: string = null, duration: number = 1500): Observable<any> {
    return this.snackBar.openFromComponent(SnackBarComponent, {
      duration: duration,
      verticalPosition: 'bottom',
      horizontalPosition: 'center',
      panelClass: 'snackbar',
      data: {
        icon_class: 'warning',
        icon: 'error_outline',
        message: message,
        actionTitle: action,
      }
    }).onAction();
  }

  showSuccessSnackBar(message: string, action: string = null, duration: number = 1500, hPosition: MatSnackBarHorizontalPosition = 'end'): Observable<any> {
    return this.snackBar.openFromComponent(SnackBarComponent, {
      duration: duration,
      verticalPosition: 'top',
      horizontalPosition: hPosition,
      data: {
        icon_class: 'ok',
        icon: 'check_circle_outline',
        message: message,
        actionTitle: action
      }
    }).onAction();
  }

  showBottomSuccessSnackBar(message: string, action: string = null, duration: number = 500): Observable<any> {
    return this.snackBar.openFromComponent(SnackBarComponent, {
      duration: duration,
      verticalPosition: 'bottom',
      horizontalPosition: 'center',
      panelClass: 'snackbar',
      data: {
        icon_class: 'ok',
        icon: 'check_circle_outline',
        message: message,
        actionTitle: action
      }
    }).onAction();
  }

  showConfirmationDialog(title: string, message: string): Observable<any> {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent);

    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.description = message;

    return dialogRef.afterClosed();
  }
}
